export const searchOnLocalizationNameAndReference = (
    items: any,
    search: string | null,
    main_local: number | null
) =>
    search && search !== ''
        ? items.filter(
              (item: any) =>
                  item?.reference?.toLowerCase().includes(search?.toLowerCase()) ||
                  item?.name?.toLowerCase().includes(search?.toLowerCase()) ||
                  item?.localization?.some(
                      (local: any) =>
                          main_local === local.locale &&
                          local.name
                              .toLowerCase()
                              .includes(search?.toLowerCase())
                  )
          )
        : [...items];

const sortByLocalizationName = (
    items: any,
    order: 'asc' | 'desc',
    main_local: number | null
) => {
    const direction = order === 'asc' ? 1 : -1;
    return items.sort((a: any, b: any) => {
        let index;
        a?.localization.forEach((local: any, i: number) => {
            local.locale === main_local ? (index = i) : null;
        });
        return index || index === 0
            ?
            !a.localization[index]?.name && order==='asc' ?direction:
            !a.localization[index]?.name && order!=='asc' ? -direction:
            !b.localization[index]?.name && order==='asc'? -direction:
            !b.localization[index]?.name && order!=='asc'? direction
                : a?.localization[index]?.name === b?.localization[index]?.name
                ? 0
                : a?.localization[index]?.name > b?.localization[index]?.name
                ? direction
                : -direction
            : 0;
    });
};

const sortByCreatedModifiedBy = (
    items: any,
    order: 'asc' | 'desc',
    order_by: string
) => {
    const direction = order === 'asc' ? 1 : -1;
    return items.sort((a: any, b: any) =>
        a?.[order_by]?.username != b?.[order_by]?.username
            ? a?.[order_by]?.username > b?.[order_by]?.username
                ? direction
                : -direction
            : 0
    );
};

const sortByComposition = (
    items: any,
    order: 'asc' | 'desc',
    index: number
) => {
    const direction = order === 'asc' ? 1 : -1;
    console.log(items, index)
    return items.sort((a: any, b: any) =>
        a?.composition[index] != b?.composition[index]
            ? a?.composition[index] > b?.composition[index]
                ? direction
                : -direction
            : 0
    );
};

export const sortAccommodationArray = (
    items: any,
    order: 'asc' | 'desc',
    order_by: string,
    main_local: number | null
) => {
    const direction = order === 'asc' ? 1 : -1;
    return order_by === 'name'
        ? sortByLocalizationName(items, order, main_local)
        : order_by === 'creator' || order_by === 'last_author'
        ? sortByCreatedModifiedBy(items, order, order_by)
        : order_by === 'composition0'
        ? sortByComposition(items, order, 0)
        : order_by === 'composition1'
        ? sortByComposition(items, order, 1)
        : items.sort((a: any, b: any) =>
                  !a[order_by] && order==='asc' ?direction:
                  !a[order_by] && order!=='asc' ? -direction:
                  !b[order_by] && order==='asc'? -direction:
                  !b[order_by] && order!=='asc'? direction
                  : a[order_by] == b[order_by]
                  ? 0
                  : a[order_by] > b[order_by]
                  ? direction
                  : -direction
          );
};




export const applyPagination = (items: any[], page: number, page_size: number) =>
    items.slice((page - 1) * page_size, page * page_size);